<div class="task-card" [ngClass]="{ required: required }">
  <p class="title">{{ task.titulo }} <span *ngIf="required">*</span></p>
  <div class="divisor"></div>
  <p class="subtitle">{{ task.descripcion }}</p>
  <mat-icon class="eye" *ngIf="clickable">visibility</mat-icon>
</div>
